<ng-container *ngIf="isAvailablePage">
  <ng-container
    *ngLet="{
      _mobile:
        settingsService.screenBreakpoint$ | async | appScreenLessThan: BreakpointTypeEnum.HalfSmall,
      _colorState: colorState$ | async
    } as obj"
  >
    <ng-container *ngIf="obj._mobile; else account">
      <div class="--flex --jc-space --align-center w-100">
        <ng-contairer [ngTemplateOutlet]="account"></ng-contairer>
      </div>
    </ng-container>

    <ng-template #account>
      <app-svg
        type="none"
        [class.--crsr-pntr]="!isMarketingFlow"
        [src]="themeState.logo$ | async"
        (click)="!isMarketingFlow && onLogoClick()"
      ></app-svg>

      <app-account-nav
        [colorState]="obj._colorState"
        [isMarketingFlow]="isMarketingFlow"
        class="ml-auto"
      ></app-account-nav>
    </ng-template>
  </ng-container>
</ng-container>
